export default {

    text_0: "Uživatelé",
    text_1: "Moji uživatelé",
    text_2: "Vytvoř si další přístupy",
    text_3: "Zde si můžeš vytvořit další uživatele, kteří mají přístup k tvému účtu. Skvělá volba, pokud máš zaměstnance.",
    text_4: "Vytvořit přístup",
    text_5: "Tvoje přístupy",
    text_6: "Jméno",
    text_7: "Příjmení",
    text_8: "E-mail",
    text_9: "Heslo",
    text_10: "Uložit",
    text_11: "Vytvořit",
    text_12: "Ukončit",
    text_13: "E-mail",
    text_14: "Jméno a příjmení",
    text_15: "Akce",
    text_16: "Upravit",
    text_17: "Smazat",

    text_edit_success: "Přístup úspěšně upraven.",
    text_create_success: "Přístup úspěšně vytvořen.",
    error_email_exists: "Email již existuje.",
    text_remove_success: "Přístup úspěšně smazán."
}
